import { useEffect, useState } from 'react';
import { getIcLink } from '../helpers/getIcLink';
import ShareAchievment from '../features/greenpill/ShareAchievment';
import ButtonNew from './ButtonNew';

function ModalPreview({ isOpen, onClose, imageUrl, title, ic, width, isShowFooter = true, footer }) {


    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = 'unset';
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-75 backdrop-blur-sm"
            onClick={onClose}
        >
            <div
                className={`relative ${width} rounded-[.625rem] bg-grayBgNormal p-6 flex flex-col`}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header with title and close button */}
                <div className='flex items-center justify-between mb-4'>
                    <p className='text-2xl text-textPrimary font-semibold'>{title}</p>
                    <ButtonNew
                        onClick={(e) => {
                            e.stopPropagation();
                            onClose();
                        }}
                        variant="closeNeutral"
                        size="xs"
                        shape="oval"
                        className="absolute top-3 right-4 py-3"
                        fixedMinWidth
                        minWidthClass="min-w-[2.5rem]"
                    >
                        <svg className="w-6 h-6 text-textSecondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </ButtonNew>

                </div>

                {/* Image container - dynamic height based on viewport */}
                <div
                    className="rounded-lg w-full bg-gray-100 overflow-hidden mb-4"

                    onClick={(e) => e.stopPropagation()}
                >
                    <img
                        src={imageUrl}
                        alt={title || "Expanded view"}
                        className="w-full h-full object-contain"
                    />
                </div>

                {/* Footer */}
                {isShowFooter && (
                    footer
                )}
            </div>
        </div>
    );
}

export default ModalPreview;


{/* <div className="flex items-center justify-between">
<div className="flex items-center gap-1">
    <img className="w-7 h-7 rounded-full" src={ic?.blockchain?.image} alt={ic?.blockchain?.name} />
    <p className="text-sm flex-1">
        View it on{' '}
        <a
            className="underline cursor-pointer text-blue-500"
            href={getIcLink(ic?.tokenAddress, ic?.blockchain?.name)}
            target="_blank"
        >
            <span className="capitalize">{ic?.blockchain?.name} </span> blockchain
        </a>
    </p>
</div>

<div>
    {onShareClick && shareData ? (
        <ShareAchievment 
            onShareClick={onShareClick}
            shareData={shareData}
        />
    ) : (
        <span className="text-gray-500">Share Button</span>
    )}
</div>
</div> */}